import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "Halaman",
    links: [
      { label: "Laman Utama", href: "/" },
      { label: "Tentang Kami", href: "/about" },
      { label: "Program", href: "/programs" },
      { label: "Derma", href: "/donate" },
      { label: "Latihan AI & Komputer", href: "/training" },
      { label: "Hubungi", href: "/contact" },
    ],
  },
  {
    title: "Program Kami",
    links: [
      { label: "Bantuan Makanan", href: "/programs" },
      { label: "Pendidikan", href: "/programs" },
      { label: "Perlindungan", href: "/programs" },
      { label: "Kesihatan", href: "/programs" },
      { label: "Latihan AI", href: "/training" },
      { label: "Latihan Komputer", href: "/training" },
    ],
  },
  {
    title: "Hubungi Kami",
    links: [
      { label: "Email: admin@muliainsan.com", href: "mailto:admin@muliainsan.com" },
      { label: "Tel: +6019-4231231", href: "tel:+60194231231" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-teal-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/73f16efe-91a8-43ba-88ee-73b3c6770cba.png"
                alt="Logo"
                className="w-10 h-10 object-contain"
              />
              <span className="font-semibold text-sm">MULIA INSAN</span>
            </div>
            <p className="text-teal-200/70 text-xs leading-relaxed mb-1">
              <span className="font-medium text-teal-200/90">No. Pendaftaran:</span> PPM-009-10-25092024
            </p>
            <p className="text-teal-200/70 text-xs leading-relaxed mb-5">
              PERTUBUHAN MULIA INSAN MALAYSIA adalah organisasi amal yang
              berdedikasi membantu pelarian, mangsa bencana, dan golongan miskin
              & asnaf di Malaysia sejak tahun 2024.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-teal-800 hover:bg-teal-700 transition-colors"
                aria-label="Facebook"
                rel="nofollow"
              >
                <i className="ri-facebook-fill text-sm" />
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-teal-800 hover:bg-teal-700 transition-colors"
                aria-label="Instagram"
                rel="nofollow"
              >
                <i className="ri-instagram-line text-sm" />
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-teal-800 hover:bg-teal-700 transition-colors"
                aria-label="WhatsApp"
                rel="nofollow"
              >
                <i className="ri-whatsapp-line text-sm" />
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-teal-800 hover:bg-teal-700 transition-colors"
                aria-label="TikTok"
                rel="nofollow"
              >
                <i className="ri-tiktok-fill text-sm" />
              </a>
            </div>
          </div>

          {/* Link columns */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-teal-200 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) =>
                  link.href.startsWith("mailto:") ||
                  link.href.startsWith("tel:") ? (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-teal-200/70 text-xs hover:text-white transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-teal-200/70 text-xs hover:text-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-teal-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-teal-200/50 text-xs">
            &copy; {new Date().getFullYear()} PERTUBUHAN MULIA INSAN MALAYSIA.
            Hakcipta Terpelihara.
          </p>
          <div className="flex items-center gap-4 text-xs text-teal-200/50">
            <a href="#" className="hover:text-white transition-colors" rel="nofollow">
              Dasar Privasi
            </a>
            <span className="text-teal-700">|</span>
            <a href="#" className="hover:text-white transition-colors" rel="nofollow">
              Terma Perkhidmatan
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}